// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
require("./util/routerEach")
const time = require('time-formater')
import store from "./vuex/index"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lpyMixin from '@/mixin/lpyMixin'

import './css/index.css';

Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.prototype.$countdown = time

Vue.use(lpyMixin);
Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js